export const environment = {
  production: true,
  apiUrl: 'https://api.dreamagility-coreservices.co.uk/api',
  clarityId: 'vg66yaoh4l',
  turnstileSiteKey: '0x4AAAAAAEPrs6iXJvEXSHlk',
};
